import React from "react";

import UnorderedList from "../../../redesign/components/UnorderedList"

const ParagraphContent = ({ children }) => (
    <UnorderedList children={children} />
)

export default ParagraphContent;